import React, { useState } from "react";
import PropTypes from "prop-types";
import StyledScrollToTop from "./ScrollToTop.styled";
import {AiOutlineArrowUp} from 'react-icons/ai';

const ScrollToTop = React.memo(props => {
  const { className } = props;
  const [showScroll, setShowScroll] = useState(false);
  
  const checkScrollTop = () => {    
    if (!showScroll && window.pageYOffset > 400){
      setShowScroll(true)    
    } else if (showScroll && window.pageYOffset <= 400){
      setShowScroll(false)    
    }  
  };

  const handleBackToTop = () => {
    window.scrollTo({top: 0, behavior: 'smooth'});
  }

  window.addEventListener('scroll', checkScrollTop)

  return (
    <StyledScrollToTop 
      onClick={handleBackToTop}
      className={`shop__back-to-top ${showScroll ? "" : "is-hidden"} ${className}`}
    >
      <AiOutlineArrowUp className="scroll-to__icon"/>
      <span className="t-hidden">Back to top</span>
    </StyledScrollToTop>
  );
});

ScrollToTop.propTypes = {
  className: PropTypes.string
};

export default ScrollToTop;